import type { SVGProps } from "react";

const IconResultSuccess = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      {...props}
      width="1em"
      height="1em"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_66_383)">
        <path
          d="M16 32C7.25333 32 0 24.7467 0 16C0 7.25333 7.25333 0 16 0C24.7467 0 32 7.25333 32 16C32 24.7467 24.7467 32 16 32ZM25.3867 11.0933C24.7467 10.4533 23.8933 10.4533 23.2533 11.0933L14.72 19.4133L10.4533 15.1467C9.81333 14.5067 8.96 14.5067 8.32 15.1467C7.68 15.7867 7.68 16.64 8.32 17.28L13.6533 22.6133C14.2933 23.2533 15.1467 23.2533 15.7867 22.6133L25.3867 13.2267C26.0267 12.5867 26.0267 11.7333 25.3867 11.0933Z"
          fill="#25F4EE"
        />
      </g>
      <defs>
        <clipPath id="clip0_66_383">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default IconResultSuccess;
